import { useEffect, useState } from "react";
import { SvgArrowDown, SvgScheduleRemove, SvgAdd } from "ui/svgs";
import { Popover } from "react-tiny-popover";
import clsx from "clsx";
import Switch from "react-switch";
import { formatMinute } from "lib/utils";
import TimePick from "ui/components/timepick";

const weekdays = [
  "sunday",
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
];

export default function Schedule({
  alertSchedules,
  setAlertSchedules,
  setContinueBtnDisabled = (disable) => {},
}) {
  const [isSTimePopoverOpen, setIsSTimePopoverOpen] = useState("");
  const [isETimePopoverOpen, setIsETimePopoverOpen] = useState("");

  const [illegalTimeRanges, setIllegalTimeRanges] = useState([]);

  const todayMsStamp = new Date().setHours(0, 0, 0, 0);

  useEffect(() => {
    setContinueBtnDisabled(illegalTimeRanges.length > 0);
  }, [illegalTimeRanges]);

  useEffect(() => {
    setIllegalTimeRanges([]);
    const newIllegalTimeRanges = [];
    alertSchedules.forEach((schedule, scheduleIndex) => {
      schedule.timeRanges.forEach((timeRange, rangeIndex) => {
        checkTimeRange(
          scheduleIndex,
          rangeIndex,
          timeRange,
          newIllegalTimeRanges,
        );
      });
    });
    setIllegalTimeRanges([...newIllegalTimeRanges]);
  }, [alertSchedules]);

  const checkTimeRange = (
    scheduleIndex: number,
    rangeIndex: number,
    curRange,
    newIllegalTimeRanges,
  ) => {
    const illegal = scheduleIndex + "-" + rangeIndex;
    if (curRange.endedAt <= curRange.startedAt) {
      if (!newIllegalTimeRanges.includes(illegal)) {
        newIllegalTimeRanges.push(illegal);
      }
    } else {
      console.log("-----illegalTimeRanges", [
        ...newIllegalTimeRanges.filter((item) => item !== illegal),
      ]);
      setIllegalTimeRanges([
        ...newIllegalTimeRanges.filter((item) => item !== illegal),
      ]);
    }
  };

  const handleAllDaySwitch = (scheduleIndex: number) => {
    alertSchedules[scheduleIndex].allDay =
      !alertSchedules[scheduleIndex].allDay;
    alertSchedules[scheduleIndex].allYear = false;
    if (!alertSchedules[scheduleIndex].allDay) {
      handleAddTimeRange(scheduleIndex);
    } else {
      alertSchedules[scheduleIndex].timeRanges = [];
    }

    console.log("-----handleAllDaySwitch alertSchedules", alertSchedules);
    setAlertSchedules([...alertSchedules]);
  };

  const handleRemoveSchedule = (scheduleIndex: number) => {
    alertSchedules.splice(scheduleIndex, 1);
    setAlertSchedules([...alertSchedules]);
  };

  const handleRemoveTimeRange = (scheduleIndex: number, rangeIndex: number) => {
    alertSchedules[scheduleIndex].timeRanges.splice(rangeIndex, 1);
    setAlertSchedules([...alertSchedules]);
  };

  const handleSTimeChange = (
    scheduleIndex: number,
    rangeIndex: number,
    date: Date,
  ) => {
    const startTime = (date.getTime() - todayMsStamp) / 1000;
    const curRange = alertSchedules[scheduleIndex].timeRanges[rangeIndex];
    curRange.startedAt = startTime;
    setAlertSchedules([...alertSchedules]);
    // setIsSTimePopoverOpen("");
  };

  const handleETimeChange = (
    scheduleIndex: number,
    rangeIndex: number,
    date: Date,
  ) => {
    let endTime = (date.getTime() - todayMsStamp) / 1000;
    endTime > 24 * 60 * 60 && (endTime = endTime - 24 * 60 * 60);
    endTime == 0 && (endTime = 24 * 60 * 60);

    const curRange = alertSchedules[scheduleIndex].timeRanges[rangeIndex];
    curRange.endedAt = endTime;
    setAlertSchedules([...alertSchedules]);
    // setIsETimePopoverOpen("");
  };

  const handleAddTimeRange = (scheduleIndex: number) => {
    alertSchedules[scheduleIndex].timeRanges.push({
      startedAt: 3600 * 8,
      endedAt: 3600 * 20,
    });
    setAlertSchedules([...alertSchedules]);
  };

  const handleWeekDaysChange = (scheduleIndex: number, day: string) => {
    const curWeekDay = alertSchedules[scheduleIndex].weekdays;
    const i = curWeekDay.findIndex((d) => d === day);
    if (i > -1) {
      curWeekDay.splice(i, 1);
    } else {
      curWeekDay.push(day);
    }

    const customOrder = [
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
      "sunday",
    ];
    curWeekDay.sort((a, b) => customOrder.indexOf(a) - customOrder.indexOf(b));
    setAlertSchedules([...alertSchedules]);
  };

  const handleAddSchedule = () => {
    alertSchedules.push({
      allDay: true,
      timeRanges: [],
      weekdays: [
        "sunday",
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday",
      ],
    });
    setAlertSchedules([...alertSchedules]);
  };

  const timeRangeLine = (
    scheduleIndex,
    rangeIndex,
    startAt: number,
    endAt: number,
  ) => {
    console.log("-----startTime", new Date(todayMsStamp + startAt));

    return (
      <div className="w-full">
        <div className="w-full flex pr-5">
          <span className="flex-grow">Start Time</span>
          <span className="flex-grow">End Time</span>
        </div>
        <div className="w-full flex mt-2 gap-4 items-center">
          <span className="flex-grow">
            <Popover
              align="start"
              isOpen={isSTimePopoverOpen === scheduleIndex + "-" + rangeIndex}
              positions={["bottom", "right", "left", "top"]} // preferred positions by priority
              onClickOutside={() => setIsSTimePopoverOpen("")} // handle click events outside of the popover/target here!
              content={
                <div className="border rounded-xl">
                  <TimePick
                    curDateTime={new Date(todayMsStamp + startAt)}
                    onChange={(date) => {
                      handleSTimeChange(scheduleIndex, rangeIndex, date);
                    }}
                  />
                </div>
              }
            >
              <div className="h-9 flex items-center ">
                <button
                  className="flex flex-grow items-center justify-between rounded-2xl hover:border-blue-500 border border-neutral-400 px-5  h-full"
                  onClick={() =>
                    setIsSTimePopoverOpen(
                      !isSTimePopoverOpen
                        ? scheduleIndex + "-" + rangeIndex
                        : "",
                    )
                  }
                >
                  <p className="text-sm">
                    {formatMinute(todayMsStamp + startAt)}
                  </p>
                  <SvgArrowDown width="12" className="fill-neutral-400" />
                </button>
              </div>
            </Popover>
          </span>
          <span className="flex-grow">
            <Popover
              align="start"
              isOpen={isETimePopoverOpen === scheduleIndex + "-" + rangeIndex}
              positions={["bottom", "right", "left", "top"]}
              onClickOutside={() => setIsETimePopoverOpen("")}
              content={
                <div className="border rounded-xl ">
                  <TimePick
                    curDateTime={new Date(todayMsStamp + endAt)}
                    onChange={(date) => {
                      handleETimeChange(scheduleIndex, rangeIndex, date);
                    }}
                  />
                  {/* <DatePicker
                    selected={new Date(todayMsStamp + endAt)}
                    onChange={(date) => {
                      handleETimeChange(scheduleIndex, rangeIndex, date);
                    }}
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={15}
                    dateFormat="hh:mm aa"
                    timeCaption="Start Time"
                    className="form-input"
                    inline
                    onClickOutside={() => setIsETimePopoverOpen("")}
                  /> */}
                </div>
              }
            >
              <div className="h-9 flex items-center ">
                <button
                  className={clsx(
                    "flex flex-grow items-center justify-between rounded-2xl hover:border-blue-500 border border-neutral-400 px-5  h-full",
                  )}
                  onClick={() =>
                    setIsETimePopoverOpen(
                      !isETimePopoverOpen
                        ? scheduleIndex + "-" + rangeIndex
                        : "",
                    )
                  }
                >
                  <p className="text-sm">
                    {formatMinute(todayMsStamp + endAt)}
                  </p>
                  <SvgArrowDown width="12" className="fill-neutral-400" />
                </button>
              </div>
            </Popover>
          </span>
          {alertSchedules[scheduleIndex]?.timeRanges?.length > 1 ? (
            <div
              className="cursor-pointer"
              onClick={() => {
                handleRemoveTimeRange(scheduleIndex, rangeIndex);
              }}
            >
              <SvgScheduleRemove
                width="22"
                className="fill-neutral-500 hover:fill-neutral-400"
              />
            </div>
          ) : (
            <span className="w-6"></span>
          )}
        </div>
        {illegalTimeRanges.includes(scheduleIndex + "-" + rangeIndex) ? (
          <div className="text-sm text-red-500 font-semibold mt-1 ml-1">
            End time cannot be earlier than start time!
          </div>
        ) : (
          <div className="h-6" />
        )}
      </div>
    );
  };
  return (
    <div className="w-full ">
      {alertSchedules.map((schedule, scheduleIndex) => {
        return (
          <div
            key={scheduleIndex}
            className="mt-8 flex flex-col w-full  p-6 rounded-3xl bg-neutral-50"
          >
            <div className="flex items-center justify-between">
              <div className="flex-grow flex gap-3 items-center ">
                <div className="text-base font-semibold">
                  Schedule {scheduleIndex + 1}
                </div>
                <Switch
                  onChange={() => {
                    handleAllDaySwitch(scheduleIndex);
                  }}
                  checked={schedule.allDay}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  onColor="#3E83F6"
                  offColor="#fff"
                  handleDiameter={20}
                  offHandleColor="#9E9E9E"
                  className="border border-zinc-200"
                  height={32}
                  width={52}
                />
                All Day
              </div>
              {alertSchedules?.length > 1 && (
                <div
                  className="cursor-pointer "
                  onClick={() => {
                    handleRemoveSchedule(scheduleIndex);
                  }}
                >
                  <SvgScheduleRemove
                    width="22"
                    className="fill-neutral-500 hover:fill-neutral-400"
                  />
                </div>
              )}
            </div>
            {!schedule.allDay &&
              schedule.timeRanges.map((timeRange, rangeIndex) => {
                return (
                  <div
                    className="flex items-center gap-3 mt-4"
                    key={rangeIndex}
                  >
                    {timeRangeLine(
                      scheduleIndex,
                      rangeIndex,
                      timeRange.startedAt * 1000,
                      timeRange.endedAt * 1000,
                    )}
                  </div>
                );
              })}
            {!schedule.allDay &&
              alertSchedules[scheduleIndex].timeRanges.length < 4 && (
                <div
                  className="w-[180px] text-blue-500 flex items-center gap-2 mt-1 cursor-pointer pl-2 hover:text-blue-400 fill-blue-500 hover:fill-blue-400"
                  onClick={() => {
                    handleAddTimeRange(scheduleIndex);
                  }}
                >
                  <SvgAdd width="15" />
                  Add Time Range
                </div>
              )}
            <div className="text-sm mb-2 mt-6">Repeat</div>
            <div className="flex gap-1">
              {weekdays.map((day) => {
                return (
                  <div
                    key={day}
                    onClick={() => {
                      handleWeekDaysChange(scheduleIndex, day);
                    }}
                    className={clsx(
                      "w-10 h-10 rounded-full leading-10 text-center text-neutral-800 cursor-pointer font-semibold",
                      schedule.weekdays.includes(day)
                        ? "bg-blue-200 hover:bg-blue-100"
                        : "border border-zinc-500 hover:border-zinc-400",
                    )}
                  >
                    {day?.at(0).toUpperCase()}
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
      {alertSchedules.length < 10 && (
        <div
          className="w-[170px] text-blue-500 flex items-center gap-2 mt-6 cursor-pointer  hover:text-blue-400 fill-blue-500 hover:fill-blue-400"
          onClick={handleAddSchedule}
        >
          <SvgAdd width="15" />
          Add Schedule
        </div>
      )}
    </div>
  );
}
